import React, { useEffect, useState } from "react";
import { FormField } from "@amzn/awsui-components-react";
import {
  IMonetaryInputProps,
  addCommasToNumberString,
  removeCommasFromNumberString,
} from "./definitions";
import styles from "./style.module.scss";

const MonetaryInput: React.FC<IMonetaryInputProps> = (
  props: IMonetaryInputProps,
) => {
  const [value, setValue] = useState(props.value);

  const isAllZeros = (numberString: string) => {
    return /^0$|^[1-9]\d*$/.test(numberString.replace(".", ""));
  };
  const isValidNumber = (numberString: string): boolean => {
    numberString = numberString.trim();
    if (numberString === "") {
      return false;
    }
    return /^-?\d*\.?(\d+)?$/.test(numberString);
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = removeCommasFromNumberString(event.target.value).trim();
    if (isValidNumber(inputValue)) {
      const numValue: number = Number(inputValue);
      if (numValue === 0 && !isAllZeros(inputValue)) {
        setValue("0");
        props.onChange("0");
      } else {
        if (inputValue.charAt(0) === "0" && inputValue.length > 1) {
          props.onChange(inputValue.substring(1));
          setValue(inputValue.substring(1));
        } else {
          setValue(inputValue);
          props.onChange(inputValue);
        }
      }
    } else if (inputValue === "-") {
      setValue(inputValue);
      props.onChange(inputValue);
    } else if (inputValue === "") {
      if (props.value === "0") {
        setValue("");
        props.onChange("");
      } else {
        setValue("0");
        props.onChange("0");
      }
    }
    if (props.refreshChanges !== undefined) {
      props.refreshChanges(inputValue.length);
    }
  };

  const displayValue =
    props.formatWithCommas && value && value !== "-" && value !== ""
      ? addCommasToNumberString(value)
      : value;

  return (
    <div className={styles.dollarInput}>
      <FormField label={props.title}>
        <div className={styles.inputContainer}>
          <span className={styles.dollarSign}>{props.currencySign}</span>
          <input
            type="text"
            value={displayValue}
            onChange={handleChange}
            className={styles.inputField}
            placeholder=""
          />
        </div>
      </FormField>
    </div>
  );
};

export default MonetaryInput;
